import moment from 'moment'
import AuthMixin from '@/components/mixins/auth-mixin'

export default {
  name: 'userInvoiceSummary',
  inject: [
    '$utils',
    '$dataStore',
    '$api',
    '$apiError'
  ],
  props: {
    accessorComponentProp: {
      type: String,
      default () { return 'userProfile' }
    }
  },
  watch: {},
  mixins: [AuthMixin],
  data () {
    return {
      company: CONFIG.COMPANY_NAME,
      companyAddress: CONFIG.COMPANY_ADDRESS,
      vat: CONFIG.VAT_NUMBER,
      hasTermsOfSale: CONFIG.HAS_TERMS_OF_SALE,
      accessorComponent: this.accessorComponentProp,
      userInfo: null,
      error: '',
      invoiceDetails: null
    }
  },
  methods: {
    emitEvent (action, data) {
      if (action !== null || action.length > 0) {
        this.$emit('user-invoice-summary-change', { action, payload: { data } })
      }
    },
    localizedMoment (date) {
      return moment(date).locale(this.$dataStore.getLanguage().code)
    },
    getInvoiceDetails () {
      const apiRequest = () => {
        this.$utils.mainLoader(true)

        this.$api.get(`${CONFIG.API_BASE_URL}/invoices/${this.$route.params.id}`)
          .then((response) => {
            this.invoiceDetails = this.filterInvoiceDetailsData(response.data)
            this.$utils.mainLoader(false)
          })
          .catch((error) => {
            this.$apiError.handleUnauthorizedError(error, { originalRequest: () => { apiRequest() } })
            this.$utils.mainLoader(false)
          })
      }
      apiRequest()
    },
    filterInvoiceDetailsData (invoiceDetailsDataSrc) {
      const invoiceDetails = this.$utils.clone(invoiceDetailsDataSrc)
      const billingDateMoment = this.localizedMoment(invoiceDetails.billingDate)
      const billingMonthMoment = this.localizedMoment(invoiceDetails.billingMonth)

      const calcSubtotal = invoiceDetails.subtotal / 100
      const calcVat = invoiceDetails.vat / 100
      const calcVatInPercent = Math.round((100 * (calcVat) / (calcSubtotal)) * 10) / 10
      const calcAmount = invoiceDetails.amount / 100

      invoiceDetails._edit = {
        amount: calcAmount,
        amountWithCurrency: `${invoiceDetails.currency} ${calcAmount.toFixed(2)}`,
        billingDate: billingDateMoment.clone().format('DD MMM YYYY'),
        billingMonth: billingMonthMoment.clone().format('MMM YYYY'),
        subtotal: calcSubtotal,
        subtotalWithCurrency: `${invoiceDetails.currency} ${calcSubtotal.toFixed(2)}`,
        vat: calcVat,
        vatWithCurrency: `${invoiceDetails.currency} ${calcVat.toFixed(2)}`,
        vatInPercent: calcVatInPercent,
        vatInPercentWithLabel: `${calcVatInPercent}%`,
        items: invoiceDetails.items
      }

      invoiceDetails._edit.items.filter((item) => {
        const playerDateStartMoment = moment(item.dateStart)

        item.playerDateStart = playerDateStartMoment.clone().format('DD MMM YYYY')
        item.playerDateStartDay = playerDateStartMoment.clone().format('DD')
        item.price = `${invoiceDetails.currency} ${item.price / 100}`
        item.periodOfBilling = ''

        /**
         * Calculate Period of Billing
         * If Billing Month and Player Date Month are the same then get the Start Day of the Player and should get the last day of the biling month
         */
        const isBillingMonthAndPlayerStartMonthTheSame = billingMonthMoment.clone().isSame(playerDateStartMoment.clone(), 'month')
        const startOfMonthBillingMonth = playerDateStartMoment.clone().startOf('month')
        const endOfMonthBillingMonth = billingMonthMoment.clone().endOf('month')

        item.periodOfBilling = `${startOfMonthBillingMonth.clone().format('DD')}-${endOfMonthBillingMonth.clone().format('DD')}`

        if (isBillingMonthAndPlayerStartMonthTheSame) {
          item.periodOfBilling = `${playerDateStartMoment.clone().format('DD')}-${endOfMonthBillingMonth.clone().format('DD')}`
        }

        return item
      })

      // Adjust userInfo for UI
      const userInfo = {
        address: (invoiceDetails.address) ? invoiceDetails.address : null,
        ccInfo: (invoiceDetails.ccInfo) ? invoiceDetails.ccInfo : null
      }

      if (userInfo.address !== null) {
        userInfo.address._edit = {
          showVat: true
        }

        if (typeof (userInfo.address.VAT) === 'undefined' || userInfo.address.VAT === null) {
          userInfo.address._edit.showVat = false
        }

        if (userInfo.address.VAT) {
          if ((typeof userInfo.address.VAT === 'string') && (userInfo.address.VAT === '')) {
            userInfo.address._edit.showVat = false
          }

          if ((userInfo.address.VAT.match(/([\s]+)/g) !== null) && (userInfo.address.VAT.match(/([\s]+)/g).length >= 1)) {
            userInfo.address._edit.showVat = false
          }
        }
      }

      this.userInfo = userInfo

      return invoiceDetails
    }
  },
  mounted () {
    this.getInvoiceDetails()
  }
}
